export default __webpack_public_path__ + "static/media/foto1.d876f119.jpg";